import React, { useState, useEffect } from 'react';
import { Modal, Button, Container, Row, Col } from 'react-bootstrap';
import Swal from 'sweetalert2';
import RepairServies from '../../../services/RepairServices';
import PoServices from "../../../services/PoServices";
import Select from "react-select";

const AddMrvForm = ({ show, handleClose, store, onSuccess }) => {
  const initialFormValues = {
    store: '',
    supplier: '',
    billingTitle: '',  // ✅ new field
    billingNo: '',
    billingDate: '',
    image: null,
    itemCount: '',
    otherCharges: '',
    totalAmount: ''
  };

  const [formValues, setFormValues] = useState(initialFormValues);
  const [previewImage, setPreviewImage] = useState('img/placeholder-img.png');
  const [suppliers, setSuppliers] = useState([]);

  // Fetch suppliers when modal opens
  useEffect(() => {
    if (show) {
      PoServices.activeSuppliers()
        .then((res) => setSuppliers(res.data || []))
        .catch((err) => {
          console.error("Failed to load suppliers", err);
          Swal.fire("Error", "Failed to fetch suppliers", "error");
        });
    }
  }, [show]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setPreviewImage(reader.result);
      reader.readAsDataURL(file);
      setFormValues({
        ...formValues,
        image: file,
      });
    }
  };

  const validateForm = () => {
    if (!formValues.store) {
      Swal.fire("Warning", "Please select a store.", "warning");
      return false;
    }
    if (!formValues.supplier) {
      Swal.fire("Warning", "Please select a supplier.", "warning");
      return false;
    }
    if (!formValues.billingNo) {
      Swal.fire("Warning", "Please enter the bill number.", "warning");
      return false;
    }
    if (!formValues.totalAmount || formValues.totalAmount < 0) {
      Swal.fire("Warning", "Please enter a valid total amount.", "warning");
      return false;
    }
    if (!formValues.billingDate) {
      Swal.fire("Warning", "Please select the bill date.", "warning");
      return false;
    }
    if (!formValues.itemCount || formValues.itemCount <= 0) {
      Swal.fire("Warning", "Please enter a valid item count.", "warning");
      return false;
    }
    if (!formValues.otherCharges || formValues.otherCharges < 0) {
      Swal.fire("Warning", "Please enter valid other bill charges.", "warning");
      return false;
    }
    if (!formValues.image) {
      Swal.fire("Warning", "Please upload an image.", "warning");
      return false;
    }
    return true;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validateForm()) return;

    try {
      const formData = new FormData();
      Object.keys(formValues).forEach((key) => {
        if (key === 'image' && formValues.image) {
          formData.append('image', formValues.image);
        } else {
          formData.append(key, formValues[key]);
        }
      });

      await RepairServies.CreateMrv(formData);
      Swal.fire("Success", "MRV form added successfully!", "success");
      handleClose();
      onSuccess();
    } catch (error) {
      Swal.fire("Error", error.response?.data?.message || "Failed to add MRV!", "error");
    }
  };

  // Reset form when modal closes
  useEffect(() => {
    if (!show) {
      setFormValues(initialFormValues);
      setPreviewImage('img/placeholder-img.png');
    }
  }, [show]);

  return (
    <Modal className="fade" show={show} onHide={handleClose}>
      <form onSubmit={handleSubmit}>
        <Modal.Header>
          <Modal.Title>
            <i className="fas fa-edit"></i> MRV Form
          </Modal.Title>
          <Button variant="" className="btn-close" onClick={handleClose}></Button>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Row>
              {/* Store Dropdown */}
              <Col md="12">
                <label>Store</label>

                <Select
                  options={store.map((s) => ({
                    value: s._id,
                    label: s.name,
                  }))}
                  value={
                    store
                      .map((s) => ({
                        value: s._id,
                        label: s.name,
                      }))
                      .find((opt) => opt.value === formValues.store) || null
                  }
                  onChange={(selected) =>
                    setFormValues({
                      ...formValues,
                      store: selected ? selected.value : "",
                    })
                  }
                  placeholder="Search Store..."
                  noOptionsMessage={() => "No stores found"}
                  isSearchable
                />
              </Col>

              {/* Supplier Dropdown */}
              <Col md="12" className="mt-3">
                <label>Supplier</label>

                <Select
                  options={suppliers.map((sup) => ({
                    value: sup._id,
                    label: `${sup?.name} - ${sup?.address?.state || ""}`,
                  }))}
                  value={
                    suppliers
                      .map((sup) => ({
                        value: sup._id,
                        label: `${sup?.name} - ${sup?.address?.state || ""}`,
                      }))
                      .find((opt) => opt.value === formValues.supplier) || null
                  }
                  onChange={(selected) =>
                    setFormValues({
                      ...formValues,
                      supplier: selected ? selected.value : "",
                    })
                  }
                  placeholder="Search Supplier..."
                  noOptionsMessage={() => "No suppliers found"}
                  isSearchable
                />
              </Col>

              {/* Bill title */}
              {/* Bill Title */}
              <Col md="6 mt-3">
                <label>Bill Title (e.g., RCT/25)</label>
                <input
                  type="text"
                  name="billingTitle"
                  value={formValues.billingTitle}
                  onChange={handleInputChange}
                  className="form-control form-control-sm"
                  placeholder="Enter Bill Title (optional)"
                />
              </Col>


              {/* Bill Number */}
              <Col md="6 mt-3">
                <label>Bill Number</label>
                <input
                  type="number"
                  name="billingNo"
                  value={formValues.billingNo}
                  onChange={handleInputChange}
                  className="form-control form-control-sm"
                />
              </Col>

              {/* Total Amount */}
              <Col md="6 mt-3">
                <label>Total Amount</label>
                <input
                  type="number"
                  name="totalAmount"
                  value={formValues.totalAmount}
                  onChange={handleInputChange}
                  className="form-control form-control-sm"
                />
              </Col>

              {/* Other Bill Charges */}
              <Col md="6 mt-3">
                <label>Other Bill Charges</label>
                <input
                  type="number"
                  name="otherCharges"
                  value={formValues.otherCharges}
                  onChange={handleInputChange}
                  className="form-control form-control-sm"
                />
              </Col>

              {/* Bill Date */}
              <Col md="6 mt-3">
                <label>Bill Date</label>
                <input
                  type="date"
                  name="billingDate"
                  value={formValues.billingDate}
                  onChange={handleInputChange}
                  className="form-control form-control-sm"
                />
              </Col>

              {/* Item Count */}
              <Col md="6 mt-3">
                <label>Item Count</label>
                <input
                  type="number"
                  name="itemCount"
                  value={formValues.itemCount}
                  onChange={handleInputChange}
                  className="form-control form-control-sm"
                />
              </Col>

              {/* Image Upload */}
              <Col md="12 mt-3">
                <label>Upload Bill Image</label>
                <input
                  type="file"
                  accept="image/*"
                  capture="environment"
                  className="form-control form-control-sm"
                  onChange={handleFileChange}
                />
                {previewImage && previewImage !== 'img/placeholder-img.png' && (
                  <div className="file-preview text-center mt-2">
                    <img src={previewImage} alt="Preview" className="img-fluid" />
                  </div>
                )}
              </Col>
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger light" onClick={handleClose}>Close</Button>
          <Button variant="primary" type="submit">Save changes</Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default AddMrvForm;
